import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from "@jaspero/ng2-alerts";
import { ConfirmationService } from "@jaspero/ng2-confirmations";
import { ResolveEmit } from "@jaspero/ng2-confirmations/src/interfaces/resolve-emit";

import { AmChartsService } from "@amcharts/amcharts3-angular";
import { CaseService } from "app/case/case.service"
import { SharedCommonService } from "app/shared/shared-common.service";
import { Incident } from "app/shared/shared.module";

import { Location } from "app/common/location";
import { Subscription } from "rxjs/Subscription";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";
import { NotificationsService } from "angular2-notifications";
import { saveAs } from 'file-saver';
import { HttpClient } from "@angular/common/http";

@Component({
    selector: 'app-case-details',
    templateUrl: './case-details.component.html',
    styleUrls: ['./case-details.component.css'],
})
export class CaseDetailsComponent implements OnInit {

    //example to be used until object populated with real data
    Incident: Incident;

    sub: Subscription;
    GettingCase: Subscription;
    ChangeIncidentStatusSubscription: Subscription;
    GetPDFSubscription: Subscription;

    constructor(private _alert: AlertsService, private _confirmation: ConfirmationService, private caseService: CaseService, private route: ActivatedRoute, private sharedCommonService: SharedCommonService, private busyLoaderService: BusyLoaderService, private _notification: NotificationsService) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            if (params && params['id']) {
                this.GetCase(params['id']);
            }
        });
    }

    private GetCase(Id) {
        var ob = this.caseService.GetCaseDetails(Id);
        this.busyLoaderService.AddLoadingObservable(ob);
        this.GettingCase = ob.subscribe(
            item => {
                this.Incident = item;
            }, err => {
                console.log(err);
            }
        );
    }

    VoiceCall() {
        this._alert.create("info", 'Making Voice Call.');
    };

    VideoCall() {
        this._alert.create("info", 'Making Video Call.');
    };

    RaiseAsEmergency() {
        this._confirmation.create("Make Emergency", "Are you sure you want to make this an emergency?")
            .subscribe((ans: ResolveEmit) => console.log(ans));
    };

    ReOpenCase() {
        this._confirmation.create("Re-Open Case", "Are you sure you want to re-open this case?")
            .subscribe((ans: ResolveEmit) => {
                if (ans.resolved) {
                    this.ChangeIncidentStatusSubscription = this.caseService.ChangeIncidentStatus(this.Incident.Id, "Current").subscribe(
                        (res) => {
                            this._notification.success("Status Changed", "Incident Status changed successfully.");
                            this.GetCase(this.Incident.Id);
                        },
                        (err) => {
                            this._notification.error("Status Change Error", "There was an error changing the status of this Incident");
                        }
                    )
                }
            });
    };

    SuspendCase() {
        this._confirmation.create("Suspending Case", "Are you sure you want to suspend this case?")
            .subscribe((ans: ResolveEmit) => {
                if (ans.resolved) {
                    this.ChangeIncidentStatusSubscription = this.caseService.ChangeIncidentStatus(this.Incident.Id, "Suspended").subscribe(
                        (res) => {
                            this._notification.success("Status Changed", "Incident Status changed successfully.");
                            this.GetCase(this.Incident.Id);
                        },
                        (err) => {
                            this._notification.error("Status Change Error", "There was an error changing the status of this Incident");
                        }
                    )
                }
            });
    };

    CloseCase() {
        this._confirmation.create("Closing Case", "Are you sure you want to close this case?")
            .subscribe((ans: ResolveEmit) => {
                if (ans.resolved) {
                    this.ChangeIncidentStatusSubscription = this.caseService.ChangeIncidentStatus(this.Incident.Id, "Closed").subscribe(
                        (res) => {
                            this._notification.success("Status Changed", "Incident Status changed successfully.");
                            this.GetCase(this.Incident.Id);
                        },
                        (err) => {
                            this._notification.error("Status Change Error", "There was an error changing the status of this Incident");
                        }
                    )
                }
            });
    };

    ToggleMenu() {
        if (this.sharedCommonService.OnMobile)
            this.sharedCommonService.ToggleMenu("sidebar-toggle");
    };
    GetPDF() {
        this.GetPDFSubscription = this.caseService.GetCasePDF(this.Incident.Id).subscribe(
            (response) => {
                var blob = new Blob([response], { type: "application/pdf" });
                this._notification.success("PDF Downloaded");
                saveAs(blob, 'themis-case-'+this.Incident.Id+this.Incident.IncidentFilename+'.pdf');
            },
            err => {
                console.log(err);
                this._notification.error("PDF Download", "There was an error downloading the PDF for this incident");
            }
        );
            //.subscribe(
            //(res) => {
            //    this._notification.success("Case ", "PDF Created");
            //    console.log(res);
            //},
            //(err) => {
            //    console.log(err);
            //    this._notification.error("PDF Dpwnload", "There was an error downloading the PDF for this incident");
            //});

    };
}



// WEBPACK FOOTER //
// ./src/app/case/details/case-details.component.ts